import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { AppConfig, CMPS_APP_CONFIG } from '../../app.config';
import { GoalModel } from '../../coaching-base/general';

@Injectable()
export class GoalService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    getActiveGoalMetrics(
        metricId: string,
        userId: string,
    ): Observable<GoalModel[]> {
        const search = new HttpParams()
            .set('metricId', metricId)
            .set('userId', userId);

        return this._http
            .get<GoalModel[]>(
                `${this._appConfig.API_ENDPOINTS.COACHING}/coaching/goalmetrics`,
                { params: search },
            )
            .pipe(
                tap((gs: GoalModel[]) => {
                    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                    if (gs && gs.length) {
                        gs.forEach((g) => {
                            if (typeof g.estimatedCompletionDate === 'string') {
                                g.estimatedCompletionDate = new Date(
                                    g.estimatedCompletionDate,
                                );
                            }
                        });
                    }
                }),
            );
    }

    disassociateGoal(goalId: number, eventId: number): Observable<boolean> {
        return this._http.post<boolean>(
            `${this._appConfig.API_ENDPOINTS.COACHING}/coaching/goalmetrics/${goalId}/${eventId}`,
            null,
        );
    }
}
